import {
  CreateFinicityConnectionInput,
  useConnectedCardsQuery,
  useEmployeeEnrollmentInfoQuery,
  useEmployeeQuery,
} from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import {
  CreateFinicityConnectionMutation,
  useCreateFinicityConnectionMutation,
} from './createFinicityConnection_gen'

type UseCreateFinicityConnectionOptions = UseGqlMutationCallbacks<
  CreateFinicityConnectionMutation,
  Omit<CreateFinicityConnectionInput, 'employeeId'>
>

export const useCreateFinicityConnection = (mutationOptions: UseCreateFinicityConnectionOptions) => {
  const { data: employeeData } = useEmployeeQuery()
  const employeeId = employeeData?.employee?.id
  const { mutateAsync: createFinicityConnection } = useCreateFinicityConnectionMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)

  return useMutationWithInvalidation(
    ({ institutionPlatformId }) => {
      if (!employeeId) throw new Error('Employee not found')
      return createFinicityConnection({ input: { employeeId, institutionPlatformId } })
    },
    optionsWithNotification,
    [
      useConnectedCardsQuery.getKey(),
      useEmployeeEnrollmentInfoQuery.getKey(), // because card connections affect account_status
    ]
  )
}
